import BaseService from '@src/services/BaseService'

class BrandService extends BaseService {
    constructor() {
        super('brands')
    }
}

export default new BrandService()
